import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AuthContext from '../../../store/AuthContext';
import Button from '../../formInputs/button/Button';
import TextBox from '../../formInputs/textBox/TextBox';
import './RequestModal.css';
import FormUpload from '../../formUpload/FormUpload';
import SelectBox from '../../formInputs/selectBox/SelectBox';
import {
    getRequestsDataForRole,
    applyFacilityAmountChange,
    applyInitialRequestSelections,
} from './RequestModal.helpers';
function RequestModalBroker(props) {
    const baseUrlFacility = process.env.REACT_APP_FACILITIES_MANAGEMENT;
    const ctx = useContext(AuthContext);
    const maxCount = 255;
    const [comment, setComment] = useState('');
    const [totalCount, setTotalCount] = useState(maxCount);
    const [, setAmount] = useState(null);
    const [, setSelectedFiles] = useState([]);
    const [isfileError] = useState(false);

    const [selectedRequest, setSelectedRequest] = useState('');
    const [, setSelectedCategory] = useState('');
    const [, setSelectedSubCategory] = useState('');

    const [facilityUpdateType, setFacilityUpdateType] = useState(null);
    const [facilityUpdateTypeError, setFacilityUpdateTypeError] = useState();
    const [facilityUpdateTypeErrorMsg] = useState();
    const [facilityAmount, setFacilityAmount] = useState(null);
    const [facilityAmountError, setFacilityAmountError] = useState(false);
    const [facilityAmountErrorMsg, setFacilityAmountErrorMsg] = useState();
    const [masterSpotWorkingCapitalDetails, setMasterSpotWorkingCapitalDetails] = useState([]);
    const [availableBuyerCreditBalance, setAvailableBuyerCreditBalance] = useState(null);
    const [requestedLimit, setRequestedLimit] = useState('');
    const [requestedLimitError, setRequestedLimitError] = useState(false);
    const [requestedLimitErrorMsg, setRequestedLimitErrorMsg] = useState('');
    const [preferredPayment, setPreferredPayment] = useState('');
    const [preferredPaymentError, setPreferredPaymentError] = useState('');
    const [customPaymentDays, setCustomPaymentDays] = useState('');
    const [customPaymentError, setCustomPaymentError] = useState('');
    const [numTrades, setNumTrades] = useState('');
    const [numTradesError, setNumTradesError] = useState('');
    const [numTradesErrorMsg, setNumTradesErrorMsg] = useState('');
    const [paymentPerformance, setPaymentPerformance] = useState('');
    const [paymentPerformanceError, setPaymentPerformanceError] = useState('');

    const handlePreferredPaymentChange = (e) => {
        const value = e.target.value;
        setPreferredPayment(value);

        if (value !== 'custom') {
            setCustomPaymentDays('');
            setCustomPaymentError('');
        }

        if (!value) {
            setPreferredPaymentError('Please select payment/credit terms');
        } else {
            setPreferredPaymentError('');
        }
    };

    const handleCustomPaymentChange = (e) => {
        const value = e.target.value;
        if (value === '' || Number(value) <= 365) {
            setCustomPaymentDays(value);
            setCustomPaymentError('');
        } else {
            setCustomPaymentError('Please enter a value less than or equal to 365');
        }
    };

    const handleNumTradesChange = (e) => {
        const value = e.target.value;

        if (/^\d{0,3}$/.test(value)) {
            setNumTrades(value);
            setNumTradesError(false);
            setNumTradesErrorMsg('');
        } else {
            setNumTradesError(true);
            setNumTradesErrorMsg('Maximum 3 digits allowed');
        }
    };

    const handlePaymentPerformanceChange = (e) => {
        const value = e.target.value;
        setPaymentPerformance(value);

        if (!value) {
            setPaymentPerformanceError('Please select payment performance');
        } else {
            setPaymentPerformanceError('');
        }
    };

    const handleRequestedLimit = (e) => {
        setRequestedLimit(e.target.value);
    };
    const handleRequestedLimitBlur = (e) => {
        if (!e.target.value) {
            setRequestedLimitError(true);
            setRequestedLimitErrorMsg('Requested limit is required');
        } else if (Number(e.target.value) > 10000000) {
            setRequestedLimitError(true);
            setRequestedLimitErrorMsg('Requested limit cannot exceed 10M');
        } else {
            setRequestedLimitError(false);
            setRequestedLimitErrorMsg('');
        }
    };
    const [requestsData] = useState(
        getRequestsDataForRole(ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role)
    );

    const handleComment = (e) => {
        const newText = e.target.value;
        const enteredCharCount = newText.length - comment.length;
        const updatedTotalCount = totalCount - enteredCharCount;

        if (updatedTotalCount >= 0) {
            setComment(newText);
            setTotalCount(updatedTotalCount);
        }
    };
    const getBuyerCreditDetails = (orgId) => {
        const payload = {
            organization_ulid: orgId,
            facility_type: props.facilityType,
        };

        axios
            .post(`${baseUrlFacility}/getFacilityByOrgID`, payload)
            .then((res) => {
                if (res.status === 200) {
                    let availableBalance = res.data.payload[0]?.available_credit_balance
                        ? res.data.payload[0]?.available_credit_balance
                        : res.data.payload[0]?.amount - res.data.payload[0]?.utilized_amount;
                    setAvailableBuyerCreditBalance(availableBalance);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    ctx.onLogout();
                }
            });
    };

    const getFacilityBalance = (facilityType) => {
        const facility = masterSpotWorkingCapitalDetails.find((f) => f.facility_type === facilityType);
        return facility ? facility.amount - facility.utilized_amount : 0;
    };
    const handleFacilityAmount = (e) => {
        applyFacilityAmountChange({
            value: e.target.value,
            facilityUpdateType,
            facilityType: props.facilityType,
            availableBuyerCreditBalance,
            getFacilityBalance,
            setFacilityAmount,
            setFacilityAmountError,
            setFacilityAmountErrorMsg,
        });
    };
    const handleFacilityUpdateType = (e) => {
        setFacilityUpdateTypeError(false);
        setFacilityUpdateType(e.target.value);
    };
    const handlefacilityAmountBlur = (e) => {
        const enteredValue = e.target.value;
        if (enteredValue < 0) {
            setFacilityAmountError(true);
            setFacilityAmountErrorMsg('Value cannot be negative');
        } else {
            setFacilityAmountError(false);
            setFacilityAmountErrorMsg('');
        }
    };

    const handleSubmitRequestBroker = () => {
        console.log('Submitting request for broker', selectedRequest);
    };
    const getMasterSpotWorkingCapitalDetails = () => {
        axios
            .get(`${baseUrlFacility}/getMasterSpotWorkingCapitalDetails`)
            .then((response) => {
                if (response.status === 200) {
                    setMasterSpotWorkingCapitalDetails(response.data.payload);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    ctx.onLogout();
                }
            });
    };

    useEffect(() => {
        const shouldLoadFacility = applyInitialRequestSelections(props, {
            setSelectedRequest,
            setAmount,
        });
        if (shouldLoadFacility) {
            getMasterSpotWorkingCapitalDetails();
            getBuyerCreditDetails(props.organizationId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.type]);

    useEffect(() => {
        setSelectedSubCategory('Select');
    }, [selectedRequest]);

    return (
        <>
            <div className='col-12 custom-modal'>
                <div className='d-flex justify-content-center align-items-center vh-100'>
                    <div className='bg-white requestModal'>
                        <p className='text-end mb-0'>
                            <span className='sf-close pe-2 cursor' onClick={props.handleRequestCloseModal}></span>
                        </p>
                        <div className='col-12 px-4 mt-2'>
                            <p className='text-neutral-900 font-h1 font-bold text-start'>Raise a Request</p>
                        </div>

                        
                        <div className='text-start px-4'>
                            <div className='row'>
                        {/* Request Type */}
                                <div className='col-4'>
                                    <p className='text-neutral-700 font-b3 mb-1'>Request Type</p>
                                    <select
                                        className='form-select form-select-sm'
                                        value={selectedRequest}
                                        onChange={(e) => {
                                            setSelectedRequest(e.target.value);
                                            setSelectedCategory('');
                                            setSelectedSubCategory('');
                                        }}
                                        disabled={props.profileType === 'investor' || props?.disabledType}>
                                        <option value=''>Select Request Type</option>
                                        {requestsData.map((request) => (
                                            <option key={request.value} value={request.value}>
                                                {request.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Full Entity Name */}
                                <div className='col-4'>
                                    <TextBox
                                        label='Full Entity Name'
                                        type='text'
                                        id='buyerOrganizationName'
                                        placeholder='Enter buyer organization'
                                        onChange={handleFacilityAmount}
                                        error={facilityAmountError}
                                        errorMessage={facilityAmountErrorMsg}
                                        name='amount'
                                        value={facilityAmount}
                                        onBlur={(e) => handlefacilityAmountBlur(e)}
                                    />
                                </div>

                                {/* Registered Country */}
                                <div className='col-4'>
                                    <SelectBox
                                        label='Registered Country'
                                        data={[
                                            { name: 'Add', value: 'add' },
                                            { name: 'Withdraw', value: 'withdraw' },
                                        ]}
                                        selectType='defaultDropdown'
                                        name='product'
                                        value={facilityUpdateType}
                                        error={facilityUpdateTypeError}
                                        errorMessage={facilityUpdateTypeErrorMsg}
                                        onChange={(e) => handleFacilityUpdateType(e)}
                                        isRequiredNeeded={true}
                                    />
                                </div>
                            </div>

                            {/* Sales Details */}
                            <div className='row mt-3'>
                                <div className='col-4'>
                                    <TextBox
                                        label='Average Monthly Sales (min. 6 months)'
                                        type='number'
                                        id='avgMonthlySales'
                                        placeholder='Enter amount'
                                        onChange={handleFacilityAmount}
                                        error={facilityAmountError}
                                        errorMessage={facilityAmountErrorMsg}
                                        name='avgMonthlySales'
                                        value={facilityAmount}
                                        onBlur={(e) => handlefacilityAmountBlur(e)}
                                    />
                                </div>

                                <div className='col-4'>
                                    <TextBox
                                        label='Total Sales (min. 6 months)'
                                        type='number'
                                        id='totalSales'
                                        placeholder='Enter amount'
                                        onChange={handleFacilityAmount}
                                        error={facilityAmountError}
                                        errorMessage={facilityAmountErrorMsg}
                                        name='totalSales'
                                        value={facilityAmount}
                                        onBlur={(e) => handlefacilityAmountBlur(e)}
                                    />
                                </div>

                                {/* Requested Limit */}
                                <div className='col-4'>
                                    <TextBox
                                        label='Requested Limit (Max 10M)'
                                        type='number'
                                        id='requestedLimit'
                                        placeholder='Enter requested limit'
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || Number(value) <= 10000000) {
                                                handleRequestedLimit(e);
                                            }
                                        }}
                                        error={requestedLimitError}
                                        errorMessage={requestedLimitErrorMsg}
                                        name='requestedLimit'
                                        value={requestedLimit}
                                        onBlur={(e) => handleRequestedLimitBlur(e)}
                                    />
                                </div>
                            </div>

                            {/* Preferred Payment, Trades & Performance */}
                            <div className='row mt-3'>
                                {/* Preferred Payment */}
                                <div className='col-4'>
                                    <SelectBox
                                        label='Preferred Payment / Credit Terms'
                                        data={[
                                            { name: '15 Days', value: '15' },
                                            { name: '30 Days', value: '30' },
                                            { name: '45 Days', value: '45' },
                                            { name: '60 Days', value: '60' },
                                            { name: 'Custom', value: 'custom' },
                                        ]}
                                        selectType='defaultDropdown'
                                        name='preferredPayment'
                                        value={preferredPayment}
                                        error={!!preferredPaymentError}
                                        errorMessage={preferredPaymentError}
                                        onChange={handlePreferredPaymentChange}
                                        isRequiredNeeded={true}
                                    />
                                </div>

                                {/* Custom Days Input */}
                                {preferredPayment === 'custom' && (
                                    <div className='col-4'>
                                        <TextBox
                                            label='Custom Days'
                                            type='number'
                                            id='customDays'
                                            placeholder='Enter custom days (Max 365)'
                                            value={customPaymentDays}
                                            onChange={handleCustomPaymentChange}
                                            error={!!customPaymentError}
                                            errorMessage={customPaymentError}
                                            name='customDays'
                                        />
                                    </div>
                                )}

                                {/* Number of Trades */}
                                <div className='col-4'>
                                    <TextBox
                                        label='Number of Trades (min. 6 months)'
                                        type='number'
                                        id='numTrades'
                                        placeholder='Enter trades'
                                        value={numTrades}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || /^\d{0,3}$/.test(value)) {
                                                handleNumTradesChange(e);
                                            }
                                        }}
                                        error={numTradesError}
                                        errorMessage={numTradesErrorMsg}
                                        name='numTrades'
                                    />
                                </div>

                                {/* Payment Performance */}
                                <div className='col-4 '>
                                    <SelectBox
                                        label='Payment Performance'
                                        data={[
                                            { name: 'Excellent (0–15 days early/on time)', value: 'excellent' },
                                            { name: 'Good (0–15 days late)', value: 'good' },
                                            { name: 'Average (15–30 days late)', value: 'average' },
                                            { name: 'Below Average (30–60 days late)', value: 'below_average' },
                                            { name: 'Unknown / No Data', value: 'unknown' },
                                        ]}
                                        selectType='defaultDropdown'
                                        name='paymentPerformance'
                                        value={paymentPerformance}
                                        error={!!paymentPerformanceError}
                                        errorMessage={paymentPerformanceError}
                                        onChange={handlePaymentPerformanceChange}
                                        isRequiredNeeded={true}
                                    />
                                </div>
                            </div>

                            {/* Document Upload */}
                            <div className='row mt-4'>
                                <div className='col-12 col-xl-6 mb-3'>
                                    <FormUpload setSelectedFiles={setSelectedFiles} title='Upload Document' />
                                </div>
                            </div>

                            {/* Comment Section */}
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <p className='float-right font-b3 text-neutral-600 mb-0'>
                                        <span className='float-start'>Comment</span>
                                        <span className='float-end'>
                                            {comment.length}/{maxCount}
                                        </span>
                                    </p>
                                    <textarea
                                        className='form-control font-b2 text-neutral-900'
                                        value={comment}
                                        onChange={handleComment}
                                        maxLength='255'></textarea>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 pb-4 px-4'>
                            <div className='text-start p-md-0 d-flex'>
                                <Button type='primary-sm' onClick={handleSubmitRequestBroker} disabled={isfileError}>
                                    Confirm
                                </Button>
                                <span className='mx-2'></span>
                                <Button type='hollow-gray-sm' onClick={props.handleRequestCloseModal}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RequestModalBroker;
